import { Container } from "@mui/material";
import logo from "../../assets/cosmo-logo-gray.svg";
import styles from "./QuestionSuccessPage.module.css";

const QuestionSuccessPage = () => (
  <Container className={styles.page} style={{ minWidth: "100%", minHeight: "100%" }} disableGutters>
    <div className={styles.content}>
      <div className={styles.logo_row}>
        <img src={logo} className={styles.logo} alt="cosmo logo" />
      </div>
      <h1 className={styles.title}>Thank You</h1>
      <p className={styles.description}>
        Thanks for using our service. You&apos;re all set to continue your Cosmo journey.
      </p>
    </div>
  </Container>
);

export default QuestionSuccessPage;
